module.exports = __webpack_public_path__ + "img/arrow_up.55e81841.svg";